import styled from 'styled-components';
import { borderRadius, colors, overline, spacing } from 'ui/theme';
import { Card } from 'ui/cardV2';
import { CardProps } from 'ui/cardV2/types';
import { MOBILE_MENU_MAX_BREAKPOINT } from 'modules/nav/constants/breakpoints';
import { MIN_DASHBOARD_CARD_HEIGHT } from '../constants';
import { Module } from '../lib/components/Module';

export const Container = styled(Module)`
  &&[data-size] {
    padding: 0;
    height: 100%;
    width: 100%;
    grid-area: "main";
    background: transparent;
    display: flex;
    flex-direction: column;
  }
  @media only screen and (max-width: ${MOBILE_MENU_MAX_BREAKPOINT}) {
    overflow: hidden;
  }

`;

export const InnerContainer = styled.div`
  height: 100%;
  background: rgba(255, 255, 255, 0.75);
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  padding: ${spacing.threeQuarter};
`;

export const DashboardSection = styled(Card).attrs({
  size: 'small',
  $minHeight: MIN_DASHBOARD_CARD_HEIGHT,
})<{ $minHeight?: string } & CardProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.base};
  align-self: stretch;
  &&&&&& {
    border: none;
    box-shadow: none;
    border-radius: ${borderRadius.xxl};
    background: ${colors.backgroundSecondary};
  }
`;

export const DashboardSectionTitle = styled.h2`
  all: unset;
  display: inline-flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  gap: ${spacing.half};
  color: ${colors.textPrimary};
  ${overline}
`;

export const DashboardSectionHeader = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${spacing.base};
`;

export const DashboardSectionContent = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: auto 1fr;
  gap: ${spacing.threeQuarter};


  @media only screen and (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

type DashboardCardProps = {
  $minHeight?: string;
} & CardProps;

export const DashboardCard = styled(Card).attrs<DashboardCardProps>({
  size: 'small',
  shadow: 'subtle',
  borderRadius: 'xxl',
  'data-dashboard-card': true,
  $minHeight: MIN_DASHBOARD_CARD_HEIGHT,
})<DashboardCardProps>`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};

  &[data-dashboard-card] {
    overflow: hidden;
    background: rgba(255, 255, 255, 0.5);
    border: ${spacing.eighth} solid ${colors.white};
  }

  ${({ $minHeight }) => $minHeight && `min-height: ${$minHeight};`}
`;
